import Vue from 'vue'
import Vuex from 'vuex'
import {AccidentsState} from "@/store/accidents";

Vue.use(Vuex)

interface State {
  accidents: AccidentsState;
}

export default new Vuex.Store<State>({})
